// Plate angle alert levels from Matt's notes: orange (warning) from 0.8
// degrees, red (critical) from 1.0. The meeting's reasoning: warn as the LVDTs
// differ by about 0.25 in across the plate. The backend counts the readings at
// each level with the same numbers (PLATE_ANGLE_*_DEG in load_test.py).
export const PLATE_ANGLE_WARNING_DEG = 0.8;
export const PLATE_ANGLE_CRITICAL_DEG = 1.0;

// 'critical', 'warning' or null for a plate angle in degrees. Compared as it
// is shown (two decimals), so 0.80 on screen is always a warning.
export function plateAngleLevel(angle) {
  if (angle === null || angle === undefined || angle === '') return null;
  const v = Math.round(Math.abs(Number(angle)) * 100) / 100;
  if (!Number.isFinite(v)) return null;
  if (v >= PLATE_ANGLE_CRITICAL_DEG) return 'critical';
  if (v >= PLATE_ANGLE_WARNING_DEG) return 'warning';
  return null;
}

// The theme palette colour for a level: warning orange, critical red.
export const PLATE_ANGLE_COLORS = { warning: 'warning', critical: 'error' };
